module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "buttonStyle": "info",
      "heading": "Permit",
      "size": "medium",
      "showText": _vm.showText,
      "buttonText": "New Permit",
      "buttonIcon": "fa fa-paperclip",
      "disableButton": !_vm.isManager('admin|finance|management|property') || _vm.readOnly
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('permit-details', {
    ref: "adp",
    attrs: {
      "row-data": _vm.rowData,
      "siteId": _vm.rowData.id,
      "editMode": true,
      "adding": true,
      "hide-panel": true,
      "table-ref": _vm.tableRef
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3af07678"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/PermitAction.vue
// module id = 1430
// module chunks = 0